export default function About() {
  const techStack = [
    "React",
    "Next.js",
    "Node.js",
    "Express",
    "MongoDB",
    "PostgreSQL",
    "Tailwind",
    "Git",
  ];

  const highlights = [
    { icon: "⚡", text: "Build modern, responsive UIs" },
    { icon: "🧠", text: "Design scalable backend APIs" },
    { icon: "🔐", text: "Implement secure authentication" },
    { icon: "🚀", text: "Optimize performance & SEO" },
    { icon: "🛠️", text: "Deploy & maintain production apps" },
  ];

  return (
    <section
      id="about"
      className="relative bg-[#0b0b0b] py-28 overflow-hidden text-white"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,180,80,0.12),transparent_60%)] animate-pulse" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(0,200,200,0.08),transparent_70%)]" />

      {/* Floating elements */}
      <div className="absolute top-1/3 right-0 w-72 h-72 bg-cyan-400/10 rounded-full blur-3xl animate-float opacity-20" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* LEFT */}
        <div className="animate-slide-left">
          <h2 className="text-5xl md:text-6xl font-bold tracking-wide mb-6">
            <span className="text-gray-300">About</span>{" "}
            <span className="text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
              Me
            </span>
          </h2>

          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            I'm a{" "}
            <span className="font-bold text-transparent bg-linear-to-r from-orange-300 to-cyan-300 bg-clip-text">
              Full-Stack Developer
            </span>{" "}
            who enjoys building scalable, user-focused web applications from
            idea to deployment. I work across the stack — crafting clean,
            responsive interfaces on the frontend and designing reliable systems
            on the backend.
          </p>

          <p className="text-gray-400 text-lg leading-relaxed">
            I care deeply about code quality, performance, and developer
            experience. Beyond writing code, I enjoy learning new technologies,
            solving real-world problems, and collaborating with others to build
            products that matter.
          </p>

          {/* Tech Stack */}
          <div className="mt-8 flex flex-wrap gap-3">
            {techStack.map((tech, index) => (
              <span
                key={tech}
                className="rounded-full glass-morphism-hover px-4 py-2 text-sm text-gray-300 hover:text-white hover:shadow-[0_0_15px_rgba(0,200,200,0.4)] transition-all cursor-default"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        {/* RIGHT – Enhanced Card */}
        <div className="relative animate-slide-right">
          {/* Background glow */}
          <div className="absolute -inset-4 bg-linear-to-r from-orange-400/20 to-cyan-400/20 rounded-3xl blur-2xl"></div>

          <div className="relative rounded-3xl glass-morphism p-8 transition-all duration-500 hover:shadow-[0_0_40px_rgba(0,200,200,0.5)] border-white/20 hover:border-cyan-400/50">
            <h3 className="text-2xl font-bold mb-6 text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
              What I Do
            </h3>

            <ul className="space-y-4">
              {highlights.map((item, index) => (
                <li key={index} className="flex items-start gap-3 group">
                  <span className="text-2xl mt-1 group-hover:scale-125 transition-transform">
                    {item.icon}
                  </span>
                  <span className="text-gray-300 group-hover:text-white transition-colors">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-linear-to-t from-black to-transparent" />
    </section>
  );
}
